import React from 'react';
import './styles/styles.css';
import { Route, Routes } from 'react-router';
import TransformationsPage from './pages/TransformationsPage';
import AddTransformationPage from './pages/AddTransformationPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import { AuthProvider } from './components/AuthContext';
import registerUnhandledRejection from './services/ErrorService';
import { UNAUTHORIZED_PATH } from './services/AuthService';

registerUnhandledRejection();

function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<TransformationsPage />} />
        <Route path="/transformations/add" element={<AddTransformationPage />} />
        <Route path="/transformations/:id/edit" element={<AddTransformationPage />} />
        <Route path={UNAUTHORIZED_PATH} element={<UnauthorizedPage />} />
      </Routes>
    </AuthProvider>
  );
}

export default App;
